import { useEffect, useRef } from 'react'
import { useT } from '@/i18n'
import { crewsMessages } from '@/i18n/messages/crews'

export const CREW_TABS = ['overview', 'performance', 'map', 'attendance', 'bonus'] as const
export type CrewTab = (typeof CREW_TABS)[number]

const LABEL = {
  overview: 'tabOverview', performance: 'tabPerformance', map: 'tabMap',
  attendance: 'tabAttendance', bonus: 'tabBonus',
} as const

/** Tab bar for the crew page. Scrolls sideways on a phone rather than wrapping. */
export function CrewTabs({ value, onChange }: { value: CrewTab; onChange: (t: CrewTab) => void }) {
  const t = useT(crewsMessages)
  const activeRef = useRef<HTMLButtonElement>(null)
  // On a phone the bar scrolls sideways; keep the open tab in view (a deep link to ?tab=bonus
  // would otherwise open with its own tab hidden off the edge).
  useEffect(() => { activeRef.current?.scrollIntoView({ inline: 'center', block: 'nearest' }) }, [value])
  return (
    <div role="tablist" className="-mx-4 flex gap-1 overflow-x-auto border-b border-neutral-200 px-4 [mask-image:linear-gradient(to_right,black_85%,transparent)] sm:[mask-image:none] dark:border-neutral-800">
      {CREW_TABS.map((k) => {
        const on = k === value
        return (
          <button
            key={k}
            ref={on ? activeRef : undefined}
            type="button"
            role="tab"
            aria-selected={on}
            onClick={() => onChange(k)}
            className={`-mb-px whitespace-nowrap border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
              on
                ? 'border-brand-600 text-neutral-900 dark:text-neutral-100'
                : 'border-transparent text-neutral-500 hover:text-neutral-800 dark:hover:text-neutral-200'
            }`}
          >
            {t(LABEL[k])}
          </button>
        )
      })}
    </div>
  )
}
